export enum EntityKeys {
  UNAVAILABILITY = 'UNAVAILABILITY',
  ORDER = 'ORDER',
  WORKING_HOURS = 'WORKING_HOURS',
  ASSIGNMENT = 'ASSIGNMENT',
  ASSIGNMENT_VISUAL_PRICE = 'ASSIGNMENT_VISUAL_PRICE',
  USER = 'USER',
  VISUALS_EDITING = 'VISUALS_EDITING',
  VISUALS_MARKETING_PROPERTY_DETAILS = 'VISUALS_MARKETING_PROPERTY_DETAILS',
  VISUALS_MARKETING_MATERIALS = 'VISUALS_MARKETING_MATERIALS',
  JOB = 'JOB',
  WORKSPACE = 'WORKSPACE',
  USER_WORKSPACE = 'USER_WORKSPACE',
  TRAVEL_COST = 'TRAVEL_COST',
  MEASUREMENT_QUOTE = 'MEASUREMENT_QUOTE',
  MEASUREMENT_PRICING = 'MEASUREMENT_PRICING',
  PF_CATEGORY_CONFIG = 'PF_CATEGORY_CONFIG',
  PF_ADDRESS_CONFIG = 'PF_ADDRESS_CONFIG',
  PF_PRODUCTS = 'PF_PRODUCTS',
  PF_INSTRUCTIONS = 'PF_INSTRUCTIONS',
  VIRTUAL_STAGING_DECORATIONS = 'VIRTUAL_STAGING_DECORATIONS',
  VIRTUAL_STAGING_FURNITURE_STYLES = 'VIRTUAL_STAGING_FURNITURE_STYLES',
  CHECKOUT_LINK = 'CHECKOUT_LINK',
  PORTAL_LINK = 'PORTAL_LINK',
  UPSELL_CONFIG = 'UPSELL_CONFIG',
  FLOOR_PLAN_TEMPLATES = 'FLOOR_PLAN_TEMPLATES',
  SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS',
  USER_STATUS = 'USER_STATUS',
  VIRTUAL_VISIT_EXTENSION_PRICE = 'VIRTUAL_VISIT_EXTENSION_PRICE',
  PROPERTY = 'PROPERTY',
  PROPERTY_ASSIGNMENTS = 'PROPERTY_ASSIGNMENTS',
  PROPERTY_ORDERS = 'PROPERTY_ORDERS',
  PROPERTY_REORDER_CONTEXT = 'PROPERTY_REORDER_CONTEXT',
  ASSIGNMENT_VISUAL = 'ASSIGNMENT_VISUAL',
  AI_VISUAL_ERASER = 'AI_VISUAL_ERASER',
  AI_VISUAL_STAGING = 'AI_VISUAL_STAGING',
  AI_VISUAL_ENHANCEMENT = 'AI_VISUAL_ENHANCEMENT',
  ORGANIZATION = 'ORGANIZATION',
  ORDER_DOCUMENTS_INVOICES = 'ORDER_DOCUMENTS_INVOICES',
  INVOICING_ADDRESS = 'INVOICING_ADDRESS',
  GUIDELINE = 'GUIDELINE',
  CREATIVE_INSTRUCTION = 'CREATIVE_INSTRUCTION',
  CRM_INTEGRATION = 'CRM_INTEGRATION',
  VISUAL = 'VISUAL',
  PURCHASE_SESSION_VISUAL = 'PURCHASE_SESSION_VISUAL',
  USER_ME = 'USER_ME',
  TRIAL_ELIGIBILITY = 'TRIAL_ELIGIBILITY',
  CONVERSATION = 'CONVERSATION',
  CONSENT = 'CONSENT',
  PF_REVAMP_CATALOGUE = 'PF_REVAMP_CATALOGUE',
  PF_REVAMP_PRICING = 'PF_REVAMP_PRICING',
  PF_REVAMP_INSTRUCTIONS = 'PF_REVAMP_INSTRUCTIONS',
  PF_REVAMP_SESSION_PRICING = 'PF_REVAMP_SESSION_PRICING',
  PF_REVAMP_KEY_PICKUP_TRAVEL_COST = 'PF_REVAMP_KEY_PICKUP_TRAVEL_COST',
  PF_REVAMP_CREATIVES = 'PF_REVAMP_CREATIVES',
  PF_REVAMP_VAT = 'PF_REVAMP_VAT',
  SOCIAL_CAMPAIGN = 'SOCIAL_CAMPAIGN',
  SOCIAL_CAMPAIGN_CONTENT_INVENTORY = 'SOCIAL_CAMPAIGN_CONTENT_INVENTORY',
}

export enum QueryType {
  GET_ONE = 'GET_ONE',
  GET = 'GET',
  LIST = 'LIST',
  LIST_MINE = 'LIST_MINE',
  INFINITE_LIST = 'INFINITE_LIST',
}
